import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta'

import app from '../view/app';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: app,
      name: 'home'
    },
    {
      path: '/search/page=:page',
      component: () => import(/* webpackChunkName: "search_result" */ "../view/SearchResult/SearchResult"),//lazy load components
      name: 'search_result'
    },
    {
      path: '/course/:id',
     component: () => import(/* webpackChunkName: "course" */ "../view/Course/CoursePage"),
      name: 'course'
    },
    {
      path: '/course/:id/syllabus',
      component: () => import(/* webpackChunkName: "course_syllabus" */ "../view/Course/Syllabus/Syllabus"),
      name: 'syllabus'
    },
    {
      path: '/domain/:domain_name',
      component: () => import(/* webpackChunkName: "domain" */ "../view/Domain/DomainPage"),
      name: 'domain'
    },
    {
      path: '/domain/:domain_name/all_courses/page=:page',
      component: () => import(/* webpackChunkName: "domain_all_courses" */ "../view/SearchResult/SearchResult"),
      name: 'all_courses_domain'
    },
    {
      path: '/domain/:domain_name/allinstructors',
      component: () => import(/* webpackChunkName: "all_instructors" */ "../view/Instructor/AllInstructors"),
      name: 'all_instructors_domain'
    },
    {
      path: '/provider/:provider_id',
      component: () => import(/* webpackChunkName: "provider" */ "../view/Provider/ProviderPage"),
      name: 'provider'
    },
    {
      path: '/provider/:provider_id/all_courses/page=:page',
      component: () => import(/* webpackChunkName: "provider_all_courses" */ "../view/SearchResult/SearchResult"),
      name: 'all_courses_provider'
    },
    {
      path: '/provider/:provider_id/allinstructors',
      component: () => import(/* webpackChunkName: "all_instructors" */ "../view/Instructor/AllInstructors"),
      name: 'all_instructors_provider'
    },
    {
      path: '/instructor/:id',
      component: () => import(/* webpackChunkName: "instructor" */ "../view/Instructor/InstructorPage"),
      name: 'instructor'
    },
    {
      path: '/noresult/:keyword',
      component: () => import(/* webpackChunkName: "result_not_found" */ "../view/SearchResult/ResultNotFound"),
      name: 'noresult'
    },
    {
      path: '/map/:id',
      component: () => import(/* webpackChunkName: "map" */ "../view/Map/Map"),
      name:'map'
    },
    {
      path: '/wiki/:concept',
      component: () => import(/* webpackChunkName: "map" */ "../view/Map/ConceptWiki"),
      name:'wiki'
    },
    {
      path: '/page',
      component: () => import(/* webpackChunkName: "page_not_found" */ "../view/General/Pagination"),
      name:'page'
    },
    {
      path: '/bigmap',
      component: () => import(/* webpackChunkName: "page_not_found" */ "../view/Map/BigMap"),
      name:'bigmap'
    },
    {
      path: '/curriculum/:goal',
      component: () => import(/* webpackChunkName: "page_not_found" */ "../view/Map/Curriculum"),
      name:'curriculum'
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "page_not_found" */ "../view/PageNotFound"),
      name:'page_not_found'
    },

  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js